import React, { useEffect, useState } from 'react';
import { Alert, Box, InputAdornment, Pagination, TextField, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { ParticipantItem } from './ParticipantCard';
import { errorMessage } from '../participantApi';
import { GradientButton, inputSx, MUTED } from '../ui';

const PAGE_SIZE = 20;

// EV-85: список опубликованных анкет с поиском и пагинацией.
const ParticipantsTab = ({ api, token, refreshKey, kinds, busy, onRequest, onAccept, onDecline }) => {
  const [query, setQuery] = useState('');
  const [applied, setApplied] = useState('');
  const [page, setPage] = useState(0);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api
      .listParticipants(token, applied || undefined, page, PAGE_SIZE)
      .then(({ data }) => !cancelled && (setData(data), setError(null)))
      .catch(err => !cancelled && setError(errorMessage(err)));
    return () => {
      cancelled = true;
    };
  }, [api, token, applied, page, refreshKey]);

  const search = e => {
    e.preventDefault();
    setPage(0);
    setApplied(query.trim());
  };

  const pages = data ? Math.ceil(data.total / PAGE_SIZE) : 0;
  const pager = pages > 1 && (
    <Box sx={{ display: 'flex', justifyContent: 'center', my: 1 }}>
      <Pagination count={pages} page={page + 1} onChange={(e, p) => setPage(p - 1)} shape='rounded' />
    </Box>
  );

  return (
    <Box>
      <Box component='form' onSubmit={search} sx={{ display: 'flex', gap: 1, mb: 2 }}>
        <TextField
          placeholder='Поиск участников'
          value={query}
          onChange={e => setQuery(e.target.value)}
          fullWidth
          size='small'
          sx={{ ...inputSx, '& .MuiOutlinedInput-root': { borderRadius: '10px', background: '#fff', height: 40, fontSize: 14 } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <SearchIcon sx={{ color: MUTED }} />
              </InputAdornment>
            ),
          }}
        />
        <GradientButton type='submit' sx={{ flexShrink: 0, height: 40, px: 2 }}>
          Найти
        </GradientButton>
      </Box>

      {error && <Alert severity='error'>{error}</Alert>}

      {data && (
        <Typography variant='body2' sx={{ color: MUTED, mb: 1.5 }}>
          {applied ? `Найдено: ${data.total}` : `Участников: ${data.total}`}
        </Typography>
      )}

      {data && data.total === 0 && (
        <Typography sx={{ color: MUTED, textAlign: 'center', mt: 4 }}>
          {applied ? 'Никого не нашли. Попробуйте другой запрос.' : 'Пока никто, кроме вас, не опубликовал анкету. Загляните позже.'}
        </Typography>
      )}

      {data && data.total > 0 && (
        <>
          {pager}
          <Box sx={{ display: 'grid', gap: 1 }}>
            {data.items.map(card => (
              <ParticipantItem
                key={card.visitorId}
                card={card}
                kinds={kinds}
                busy={busy}
                onRequest={onRequest}
                onAccept={onAccept}
                onDecline={onDecline}
              />
            ))}
          </Box>
          {pager}
        </>
      )}
    </Box>
  );
};

export default ParticipantsTab;
